import { notContainsOnlySpaces, regexPhoneNumber } from "src/utils";

export const validationIotCallingInput = (fieldValues, temp) => {
  if ("phoneNumber" in fieldValues) {
    if (!regexPhoneNumber(fieldValues.phoneNumber)) {
      temp.phoneNumber = "Phone number invalid";
    } else {
      temp.phoneNumber = "";
    }
  }

  return temp;
};

export const validationIotCallingCampaignInput = (fieldValues, temp) => {
  if ("campaignId" in fieldValues) {
    temp.campaignId = notContainsOnlySpaces(fieldValues.campaignId)
      ? ""
      : "This field is required.";
  }

  // if ("campaignName" in fieldValues) {
  //   temp.campaignName = notContainsOnlySpaces(fieldValues.campaignName)
  //     ? ""
  //     : "This field is required.";
  // }

  return temp;
};
